/**
 * Import Dependency
 */
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { injectIntl } from 'react-intl'
import math from 'lodash/math'
import * as basketActions from '../../actions/components/basket'
import * as historyActions from '../../actions/components/history'
import * as navbarActions from '../../actions/components/navbar'

/**
 * Import Component
 */
import Checkout from '../../components/scenes/Checkout'

/**
 * Declare Variable
 */
const mapStateToProps = (state, props) => {
  const basket = state.basket
  const historyList = state.history
  const merchant = state.merchant
  const orders = props.isHistory ? state.history : state.orders
  const totalOfDishsFromOrder = math.sumBy(orders, (item) => item.quantity)

  return {
    basket: basket,
    merchant: merchant,
    historyList: historyList,
    order: {
      list: orders,
      totalOfDishsFromOrder: totalOfDishsFromOrder,
    },
    isSwitchOnEditMode: state.isSwitchOnEditMode,
    isSwitchOnRightSideBar: state.isSwitchOnRightSideBar,
    isTakeaway: state.basket.isTakeaway,
    isSwitchClearAllOrdersMode: state.isSwitchClearAllOrdersMode,
  }
}
const mapDispatchToProps = (dispatch) => {
  const {
    setBasketRemark,
    resetBasket,
    resetOrder,
    resetStash,
  } = bindActionCreators(basketActions, dispatch)

  const {
    getOrderHistories,
  } = bindActionCreators(historyActions, dispatch)

  const {
    switchRightSideBar,
    // switchEditMode,
    switchClearAllOrdersMode,
  } = bindActionCreators(navbarActions, dispatch)

  return {
    setBasketRemark,
    resetBasket,
    resetOrder,
    resetStash,
    getOrderHistories,
    switchRightSideBar,
    // switchEditMode,
    switchClearAllOrdersMode,
  }
}

/**
 * Export
 */
export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(Checkout)))



// WEBPACK FOOTER //
// ./src/containers/scenes/Checkout.js